import { Injector, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { deepCopy, getDataScopeByPermission, getRoleScopeColumnMappings, isNullOrEmpty, trimString } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExportService } from '../../services/export.service';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { HttpErrorResponse } from '@angular/common/http';
import { Table } from 'primeng/table';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-export-search',
  templateUrl: './export-search.component.html',
  styleUrls: ['./export-search.component.scss'],
})
export class ExportSearchComponent
  extends SessionBaseComponent
  implements OnInit {
  readonly preferenceKey: string;
  readonly detailPreferenceKey: string;
  @ViewChild('createDt') createDt!: CalendarComponent;
  isSearchFormOpen: boolean;
  exportRows: any[];
  selectedCols: any[];
  columns: any[];
  detailColumns: any[];
  isLoading: boolean;
  isShowImportModal: boolean;
  isShowHKImportModal: boolean;
  isShowBillingViewerModal: boolean;
  isImportLoding: boolean;
  bookingNoFile: any;
  isHkFacility: boolean;

  currentRowData: any;

  //Import DO
  isImportFormOpen: boolean;
  searchImportDoParams: any;
  importDos: any[];
  doObjs: any[];

  searchForm!: FormGroup;
  invoiceForm!: FormGroup;
  invoiceHKForm!: FormGroup;
  invoiceSubmitted: boolean;
  searchParams: any;
  bookingInfo: any;

  //options
  orgIdOptions: any[];
  statusOptions: any[];
  forwarderOptions: any[];
  docTypeOptions: any[];
  docType1Options: any[];
  currenyOptions: any[];
  exportCodeOptions: any[];
  bookingForwarderList: any[];
  toCountryOptions: any[];
  toCityOptions: any[];
  shipMethodOptions: any[];
  hkFacilityOptions: any[];

  readonly permissionCode = PermissionConstants.ViewExportDeclaration;
  currentLang: string = this.laasSetting.language;
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "exportDeclarationNo",
    direction: -1
  };

  @ViewChild(DataTableComponent) table!: DataTableComponent;

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private fb: FormBuilder,
    private exportService: ExportService,
    private datePipe: DatePipe,
    private dropdownOptionService: DropdownOptionsService,
    private commonDataService: CommonDataService
  ) {
    super(injector);

    this.isSearchFormOpen = true;
    this.exportRows = [];
    this.isLoading = false;
    this.isShowImportModal = false;
    this.isShowHKImportModal = false;
    this.isShowBillingViewerModal = false;
    this.isHkFacility = ['HK', 'SCDG','HKFL','HKHT','HKHF'].includes(this.laasSetting.facility);
    this.preferenceKey = UserPreferenceConstants.ExportSearch;
    this.detailPreferenceKey = UserPreferenceConstants.ExportDetail;


    //Import DO
    this.isImportLoding = false;
    this.isImportFormOpen = true;
    this.searchImportDoParams = {};
    this.importDos = [];
    this.doObjs = [];

    //dropdown List
    this.orgIdOptions = [];
    this.statusOptions = [];
    this.forwarderOptions = [];
    this.docTypeOptions = [];
    this.docType1Options = [];
    this.currenyOptions = [];
    this.exportCodeOptions = [];
    this.bookingForwarderList = [];
    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.shipMethodOptions = [];
    this.hkFacilityOptions = [];

    const hkColumns = [
      { field: 'bookingNo', header: 'ExportDeclarationQuery.MainTable.BookingNo' },
      { field: 'portOfLoadingDischargeName', header: 'ExportDeclarationQuery.MainTable.PortOfLoadingDischargeName' },
      { field: 'toCountry', header: 'ExportDeclarationQuery.MainTable.ToCountry' },
      { field: 'toCity', header: 'ExportDeclarationQuery.MainTable.ToCity' },
      { field: 'containerNo', header: 'ExportDeclarationQuery.MainTable.ContainerNo' },
      { field: 'consigneeCompany1', header: 'ExportDeclarationQuery.MainTable.ConsigneeCompany1' },
      { field: 'consigneeCompany2', header: 'ExportDeclarationQuery.MainTable.ConsigneeCompany2' },
      { field: 'consigneeAddress1', header: 'ExportDeclarationQuery.MainTable.ConsigneeAddress1' },
      { field: 'consigneeAddress2', header: 'ExportDeclarationQuery.MainTable.ConsigneeAddress2' },
      { field: 'letterOrgId', header: 'ExportDeclarationQuery.MainTable.LetterOrgId' },
      { field: 'flyNo1', header: 'ExportDeclarationQuery.MainTable.HK.FlightNum1' },
      { field: 'flyNo2', header: 'ExportDeclarationQuery.MainTable.HK.FlightNum2' },
      { field: 'flyDt1', header: 'ExportDeclarationQuery.MainTable.HK.FlightDate1', dataType: 'date'  },
      { field: 'shipMethod', header: 'ExportDeclarationQuery.MainTable.ShipMethod'  },
    ];

    const hkDontWantColumns = [
      { field: 'exportCode', header: 'ExportDeclarationQuery.MainTable.DomesticForeign' },
      { field: 'exportType', header: 'ExportDeclarationQuery.MainTable.ExportMethod' },
      { field: 'docType1', header: 'ExportDeclarationQuery.MainTable.CalculationMethod' },
      { field: 'freeOnBoardNtdAmount', header: 'ExportDeclarationQuery.MainTable.FCAFOBPriceAccount' },
      { field: 'freeOnBoardChargeAmount', header: 'ExportDeclarationQuery.MainTable.PromotionFeeAccount' },
      { field: 'flyNo1', header: 'ExportDeclarationQuery.MainTable.FlightNum1' },
      { field: 'flyNo2', header: 'ExportDeclarationQuery.MainTable.FlightNum2' },
      { field: 'flyDt1', header: 'ExportDeclarationQuery.MainTable.FlightDate1', dataType: 'date'  },
      { field: 'flyDt2', header: 'ExportDeclarationQuery.MainTable.FlightDate2', dataType: 'date'  },
    ]

    this.columns = [
      { field: 'facility', header: 'ExportDeclarationQuery.MainTable.Facility' },
      { field: 'exportDeclarationNo', header: 'ExportDeclarationQuery.MainTable.ExportDeclarForm' },
      { field: 'docNo', header: `ExportDeclarationQuery.MainTable${this.isHkFacility ? '.HK' : ''}.IdenNum` },
      { field: 'status', header: 'ExportDeclarationQuery.MainTable.Status' },
      { field: 'bookingForwarder', header: 'ExportDeclarationQuery.MainTable.Forwarder' },
      { field: 'orgId', header: 'ExportDeclarationQuery.MainTable.Company' },
      { field: 'consigneeKey', header: 'ExportDeclarationQuery.MainTable.CustomerCode' },
      { field: 'exportDt', header: 'ExportDeclarationQuery.MainTable.DeclarDate', dataType: 'date' },
      { field: 'docType', header: 'ExportDeclarationQuery.MainTable.DeclarType' },
      { field: 'currency', header: 'ExportDeclarationQuery.MainTable.Currency' },
      { field: 'exchangeRate', header: 'ExportDeclarationQuery.MainTable.ExchangeRate' },
      { field: 'exportAmount', header: 'ExportDeclarationQuery.MainTable.OriginCurrenAnt' },
      { field: 'exportNtdAmount', header: 'ExportDeclarationQuery.MainTable.AccountCurrenAnt' },
      { field: 'freeOnBoardAmount', header: `ExportDeclarationQuery.MainTable${this.isHkFacility ? '.HK' : ''}.FCAFOBPrice` },
      { field: 'mawbNo', header: 'ExportDeclarationQuery.MainTable.MAWB' },
      { field: 'expressBill', header: 'ExportDeclarationQuery.MainTable.HAWB' },
      { field: 'reference', header: 'ExportDeclarationQuery.MainTable.Remarks' },
      { field: 'createUser', header: 'ExportDeclarationQuery.MainTable.Creator' },
      { field: 'createDt', header: 'ExportDeclarationQuery.MainTable.CreationTime', dataType: 'date' },
      { field: 'updateDt', header: 'ExportDeclarationQuery.MainTable.EditTime', dataType: 'date' },
    ];

    this.detailColumns = [
      { field: '__delete', header: 'ExportDeclarationQuery.SubTable.Form.Delete', sort: false },
      { field: 'facility', header: 'ExportDeclarationQuery.SubTable.Form.Facility' },
      { field: 'invoiceNo', header: 'ExportDeclarationQuery.SubTable.Form.InvoiceNum' },
      { field: 'doNo', header: `ExportDeclarationQuery.SubTable.Form${this.isHkFacility ? '.HK' : ''}.OriginTransactionNum` },
      { field: 'invoiceAmount', header: 'ExportDeclarationQuery.SubTable.Form.OriginCurrencyAnt' },
      { field: 'exchangeRate', header: 'ExportDeclarationQuery.SubTable.Form.ExchangeRate' },
      { field: 'department', header: 'ExportDeclarationQuery.SubTable.Form.Department' },
      { field: 'salesCode', header: 'ExportDeclarationQuery.SubTable.Form.SalesCode' },
      { field: 'invoiceNtdAmount', header: 'ExportDeclarationQuery.SubTable.Form.InvoiceAntNTD' },
      { field: 'orgId', header: 'ExportDeclarationQuery.SubTable.Form.Company' },
      { field: 'shipCorp', header: 'ExportDeclarationQuery.SubTable.Form.ShipOutComp' },
      { field: 'createUser', header: 'ExportDeclarationQuery.SubTable.Form.CreateBy' },
      { field: 'createDt', header: 'ExportDeclarationQuery.SubTable.Form.CreationTime', dataType: 'date' },
      { field: 'updateUser', header: 'ExportDeclarationQuery.SubTable.Form.LastUpdateBy' },
      { field: 'updateDt', header: 'ExportDeclarationQuery.SubTable.Form.LastUpdateTime', dataType: 'date' },
    ]

    if (this.isHkFacility) {
      this.columns = [...this.columns, ...hkColumns]
      .map((e) => ({ ...e, sort: true}));
    }
    if (!this.isHkFacility) {
      this.columns = [...this.columns, ...hkDontWantColumns];
    }

    this.selectedCols = this.columns;

    this.searchParams = {
      facility: this.laasSetting.facility,
      exportDeclarationNo: [],
      docNo: [],
      invoiceNo: [],
      doNo: [],
      consigneeKey: [],
      mawbNo: [],
      expressBill: [],
      orgId: [],
      letterOrgId: [],
      status: [],
      bookingForwarder: [],
      shipMethod: [],
      createStartDate: "",
      createEndDate: "",
      createUser: [],
      bookingNo: [],
    }

    this.searchForm = this.fb.group({
      facility: this.laasSetting.facility,
      exportDeclarationNo: [],
      docNo: [],
      invoiceNo: [],
      doNo: [],
      consigneeKey: [],
      mawbNo: [],
      expressBill: [],
      orgId: [],
      letterOrgId: [],
      status: "",
      bookingForwarder: [],
      shipMethod: [],
      createStartDate: "",
      createEndDate: "",
      createUser: [],
      bookingNo: [],
    });

    this.invoiceSubmitted = false;
    var now = new Date();
    var before31Days = now.addDays(-31);

    this.invoiceForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [now, Validators.required],
      invoiceNoStart: [],
      invoiceNoEnd: [],
    });

    this.invoiceHKForm = this.fb.group({
      doNos: [null, Validators.required],
    });

    this.searchImportDoParams.startDate = this.datePipe.transform(before31Days, "yyyy/MM/dd");
    this.searchImportDoParams.endDate = this.datePipe.transform(now, "yyyy/MM/dd");
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    //options
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "").subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    this.facilityService
      .getExportStatusOptions(this.laasSetting.facility)
      .subscribe({
        next: (result: { optionCode: string, optionDesc: string }[]) => {
          this.statusOptions = result.map((x) => {
            return {
              label: `${x.optionCode}-${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        },
      });

    this.commonDataService.getAppCsmSetting('HKFacilitySetting').subscribe({
      next:(option:any)=>{
        this.hkFacilityOptions = option.appCsmSettingDetailList;
        console.log("this.hkFacilityOptions" + this.hkFacilityOptions);
      }
    });

    this.facilityService.getForwarderOptions(this.laasSetting.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getDocType1Options().subscribe({
      next: result => {
        this.docType1Options = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currenyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getExportCodeOptions(this.laasSetting.facility).subscribe({
      next: result => {
        this.exportCodeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionService.getToCountryOptions().subscribe({
      next: (options: any[]) => {
        this.toCountryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.toCityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });
    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    //default filter
    const exportDeclarationNo = this.routeStateService.getCurrentAndConsume()?.data?.exportDeclarationNo;
    if (!isNullOrEmpty(exportDeclarationNo)) {
      this.searchParams.exportDeclarationNo.push(exportDeclarationNo);
      this.searchExportDeclaration();
    }

    this.dropdownOptionService.getForwarderOptions()
      .subscribe({
        next: result => {
          this.bookingForwarderList = result;
        }
      });
  }

  onChipsAdd(event: any, formControlName: string): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').map(x => x.trim()).filter(x => isNullOrEmpty(x) === false && x !== '\r\n');

    let doNos: string[] = this.searchForm.controls[formControlName].value;
    doNos.splice(doNos.indexOf(value));
    doNos = doNos.concat(parsedValues);

    this.searchForm.controls[formControlName].setValue(doNos);
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.table.setCurrentPage(0);
    this.searchExportDeclaration();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchExportDeclaration();
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.searchExportDeclaration();
  }

  searchExportDeclaration(): void {

    this.isLoading = true;

    const params = deepCopy(this.searchParams);
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.roleScopeColumnMappings = getRoleScopeColumnMappings(this.userProfile, this.permissionCode);
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;
    this.exportService.queryExport(params)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.isSearchFormOpen = false;
      }))
      .subscribe({
        next: response => {
          this.exportRows = response.content;
          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
          this.table.setPageInfo(this.pageInfo.totalRecords);
        },
        error: (err: HttpErrorResponse) => {
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;
          this.table.setPageInfo(this.pageInfo.totalRecords);
          this.toastErrorMessage(err.error);
        },
      });
  }

  async searchDetailClick({ rowData, expanded }: { rowData: any, expanded: boolean }): Promise<void> {
    if (!expanded) {
      await this.getExportDetail(rowData);
    }
  }

  getTotalAmount(exportMain: any): any {
    console.log('exportMain: ' + JSON.stringify(exportMain));

    if (exportMain.details && exportMain.details.length > 0) {
      let amount = exportMain.details.map((x: any) => { return x.invoiceAmount }).reduce((sum: any, x: any) => sum + x);
      let amountNtd = exportMain.details.map((x: any) => { return x.invoiceNtdAmount }).reduce((sum: any, x: any) => sum + x);

      return {
        invoiceAmount: amount,
        invoiceNtdAmount: amountNtd
      };
    } else {
      return {
        invoiceAmount: "",
        invoiceNtdAmount: ""
      };
    }
  }

  confirmExportBtn(event: any, exportHeader: any): void {
    var exportDeclarationNo = exportHeader.exportDeclarationNo;

    this.exportService.checkExport(exportDeclarationNo).subscribe({
      next: result => {
        if (result.flag == "X") {
          this.toastService.warn(result.message);
          return;
        }
        if (result.flag == "F") {
          //final export
          this.exportService.finalExport(exportDeclarationNo).subscribe({
            next: result => {
              if (result.flag == "F") {
                this.toastService.success(result.message);
                exportHeader.status = "2";
                this.searchDetailClick({ rowData: exportHeader, expanded: false });
              } else {
                this.toastService.error(result.message);
              }
            }
          });
          return;
        }
        //是否繼續執行出口報關單確認
        this.translateService.get('ExportDeclarationQuery.Confirm.ContinueExecute')
          .subscribe({
            next: continueExecute => {
              this.confirmationService.confirm({
                message: result.message,
                header: continueExecute,
                rejectVisible: true,
                accept: () => {
                  this.exportService.finalExport(exportDeclarationNo).subscribe({
                    next: result => {
                      if (result.flag == "F") {
                        this.toastService.success(result.message);
                        exportHeader.status = "2";
                        this.searchDetailClick({ rowData: exportHeader, expanded: false });
                      } else {
                        this.toastService.error(result.message);
                      }
                    }
                  });
                },
                reject: () => {
                  this.confirmationService.close();
                }
              });
            }
          });

        //this.toastService.error(result.message);
      }
    })
  }

  deleteExport(event: any, exportHeader: any): void {
    var exportDeclarationNo = exportHeader.exportDeclarationNo;

    this.exportService.deleteExport(exportDeclarationNo).subscribe({
      next: result => {
        if (result.flag == "F") {
          this.toastService.success(result.message);
          exportHeader.status = "0";
          this.searchDetailClick({ rowData: exportHeader, expanded: false });
        } else {
          this.toastService.error(result.message);
        }
      }
    })
  }

  deleteDetail(event: any, exportHeader: any, exportDetail: any): void {
    // 確定要刪除嗎?
    this.translateService.get('ExportDeclarationQuery.Confirm.ConfirmDelete')
      .subscribe({
        next: result => {
          this.confirmationService.confirm({
            target: event.target,
            message: result,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.exportService.deleteExportDetail(exportDetail.exportDeclarationNo, exportDetail.doNo).subscribe({
                next: result => {
                  this.searchDetailClick({ rowData: exportHeader, expanded: false });
                },
                error: err => {
                  this.toastErrorMessage(err.error);
                }
              });
            },
            reject: () => {
              //reject action
            }
          });
        }
      });


  }

  fake(event: any, rowData: any): void {

  }

  exportLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo('/TransportOperation/ExportHeaderDetail', rowData, true);
  }

  openImportBtn(event: any, exportHeader: any): void {
    this.importDos = [];
    this.doObjs = [];
    this.invoiceSubmitted = false;
    const now = new Date();
    const before31Days = now.addDays(-31);

    this.invoiceForm.patchValue({
      startDate: before31Days,
      endDate: now,
      invoiceNoStart: [],
      invoiceNoEnd: [],
    });
    this.invoiceHKForm.reset();

    this.currentRowData = exportHeader;
    this.searchImportDoParams.exportDeclarationNo = exportHeader.exportDeclarationNo;

    const isHKfacility = this.hkFacilityOptions.some(
      x => x.setupValue === exportHeader.facility
    );

    console.log("this.isHKfacility" + isHKfacility);
    console.log("this.exportHeader.facility" +  exportHeader.facility);
    if (isHKfacility) {
      this.isShowHKImportModal = true;
    } else {
      this.isShowImportModal = true;
    }

  }

  openBillingViewerBtn(event: any, exportHeader: any): void {
    this.isShowBillingViewerModal = true;
    // this.bookingNoFile = '01BA2107090002';
    this.bookingNoFile = exportHeader.exportDeclarationNo;
    this.bookingInfo = exportHeader;
  }

  openBillingFeeBtn(event: any, exportHeader: any): void {
    this.exportService.saveBillingBy(exportHeader.exportDeclarationNo)
      .pipe(finalize(() => this.isImportLoding = false))
      .subscribe({
        next: result => {
          this.toastService.success('完成');
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  closeBilling(event: any): void {
    this.isShowBillingViewerModal = false;
  }

  searchImportDoClickBtn(event: any): void {
    this.invoiceSubmitted = true;

    if (this.invoiceForm.invalid) {
      //請檢查是否有必填欄位尚未填寫
      this.translateService.get('ExportDeclarationQuery.Alert.CheckRequiredFields')
        .subscribe({
          next: result => {
            this.toastService.warn(result);
          }
        });
      return;
    }

    this.isImportLoding = true;

    var startDate = new Date(this.searchImportDoParams.startDate ?? "1911/01/01").toISOString();
    var endDate = new Date(this.searchImportDoParams.endDate ?? "2999/12/31").toISOString();

    this.exportService.queryImportDos(this.searchImportDoParams.exportDeclarationNo, startDate, endDate)
      .pipe(finalize(() => this.isImportLoding = false))
      .subscribe({
        next: result => {
          this.importDos = result;
        },
        error: err => {
          if (!isNullOrEmpty(err.error.message)) {
            this.toastErrorMessage(err.error.message);
            return;
          }
          this.toastErrorMessage(err.error);
        }
      });
  }

  searchImportHKDoClickBtn(event: any): void {
    this.invoiceSubmitted = true;
    if (this.invoiceHKForm.invalid) {
      this.translateService.get('ExportDeclarationQuery.Alert.CheckRequiredFields')
        .subscribe({
          next: result => {
            this.toastService.warn(result);
          }
        });
      return;
    }

    this.exportService.queryImportHKDos(this.searchImportDoParams.exportDeclarationNo, this.invoiceHKForm.value.doNos)
      .pipe(finalize(() => this.isImportLoding = false))
      .subscribe({
        next: result => {
          this.importDos = result;
        },
        error: err => {
          if (!isNullOrEmpty(err.error.message)) {
            this.toastErrorMessage(err.error.message);
            return;
          }
          this.toastErrorMessage(err.error);
        }
      });
  }

  resetBtnClick(event: any): void {
    this.createDt.ngOnInit();
    this.searchForm.reset();
    this.searchParams.shipMethod = [];
    this.searchParams.createStartDate = null;
    this.searchParams.createEndDate = null;
  }

  importDoBtnLCick(event: any): void {
    this.loader.show();

    if (this.doObjs.length == 0){
      this.translateService.get('Common.Message.PleaseSelectRow')
        .subscribe((msg: string) => {
          this.toastService.error(msg);
          this.loader.hide();
        });
      return;
    }

    var deliveryOrders = [...this.doObjs].map((x: any) => {
      x.invoice_DATE = new Date(x.invoice_DATE).toISOString();
      return x;
    });

    this.exportService.importExportDetail({
      exportDeclarationNo: this.searchImportDoParams.exportDeclarationNo,
      deliveryOrders: deliveryOrders,
      createUser: this.userProfile.userName
    }).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
          .subscribe({
            next: msg => {
              this.toastService.success(msg);
              this.invoiceForm.patchValue({
                invoiceNoStart: [],
                invoiceNoEnd: [],
              });
              this.invoiceHKForm.patchValue({
                doNos: [],
              });
              this.isShowImportModal = false;
              this.isShowHKImportModal = false;
              this.searchDetailClick({ rowData: this.currentRowData, expanded: false });
            }
          });
      },
        error: err => {
          this.loader.hide();
          if (!isNullOrEmpty(err.error.errorMsg)) {
            this.toastErrorMessage(err.error.errorMsg);
            return;
          }
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.loader.hide();
        }
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.invoiceForm.controls; }
  get hkf() { return this.invoiceHKForm.controls; }

  async getExportDetail(rowData: any): Promise<void> {
    this.loader.show();
    try {
      var result = await this.exportService.getExportDetail(rowData.exportDeclarationNo);
      rowData.details = result;
    } catch (err: any) {
      console.log('get export detail occur error: ' + err);
    }
    this.loader.hide();
  }

  confirmDeleteBtn(event: any, exportHeader: any): void {
    var exportDeclarationNo = exportHeader.exportDeclarationNo;
    var status = exportHeader.status;
    //確定取消此筆出口報單?
    this.translateService.get('ExportDeclarationQuery.Confirm.ConfirmCancelExport')
      .subscribe({
        next: confirmCancelExport => {
          //確定取消
          this.translateService.get('ExportDeclarationQuery.Confirm.ConfirmCancel')
            .subscribe({
              next: confirmCancel => {
                this.confirmationService.confirm({
                  message: confirmCancelExport,
                  header: confirmCancel,
                  accept: () => {
                    this.exportService.deleteExportHeader(exportDeclarationNo).subscribe({
                      next: result => {
                        if (result.flag === 'F') {
                          this.toastService.success(result.message);
                          const params = deepCopy(this.searchParams);
                          params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
                          params.roleScopeColumnMappings = getRoleScopeColumnMappings(this.userProfile, this.permissionCode);
                          params.pageIndex = this.pageInfo.pageIndex;
                          params.pageSize = this.pageInfo.pageSize;
                          params.sortOrder = this.sortOrder;
                          this.exportService.queryExport(params).subscribe({
                            next: result => {
                              this.exportRows = result;
                            }
                          });
                        }
                        else {
                          this.toastService.error(result.message);
                        }
                      }
                    });
                  },
                  reject: () => {
                    this.confirmationService.close();
                  }
                });
              }
            });

        }
      });

  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "createDt" :
        this.searchParams.createStartDate = date.startDate;
        this.searchParams.createEndDate = date.endDate;
        break;
    }
  }

  formatTableTitle(exportRow: any): string {
    return `出口報關單(${exportRow.exportDeclarationNo})明細`;
  }
}
